import React, { ReactNode } from "react";
import { Grid, Container } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { SectionTitle } from "Components/CommonComponents";
import LoadingIndicator from "Components/LoadingIndicator";
import useHomePageData from "hooks/useHomePageData";
import { shuffleArray } from "utils/helpers";
import style from "style";
import Carousel from "./Carousel";
import QuickLinks from "./Quicklinks";
import "./Home.css";
import FeaturedProducts from "./FeaturedProducts";
import { RenderNews2 } from "Components/About/CommonComponentsAbout";
import AdvisoryItem from "./AdvisoryItem";
import DividerButton from "./DividerButton";

const Home = ({ classes }): ReactNode => {
  const {
    carouselData,
    loading,
    financialData,
    quickLinks,
    latest_news,
    advisories,
  } = useHomePageData();

  if (loading) {
    return <LoadingIndicator isLoading={true} />;
  }
  return (
    <div className={classes.root}>
      <Carousel carouselData={shuffleArray(carouselData)} />
      {quickLinks && <QuickLinks quickLinks={quickLinks} />}
      <br />
      <FeaturedProducts header="Featured Products" list={financialData} />
      <br />
      <div
        className="background-color-light-gray"
        style={{ padding: "30px 0 60px" }}
      >
        <Container>
          <SectionTitle
            header="Latest News"
            fontColor="primary"
            transformText={false}
          />
          <br />
          <Grid container justify="center" spacing={5}>
            <RenderNews2 showImage hideDate sm={12} newsArray={latest_news} />
          </Grid>
          <br />
          <br />
          <DividerButton link="about/newsroom" button="View All News" />
        </Container>

        <br />
        <Container>
          {" "}
          <SectionTitle
            header="Advisories"
            fontColor="primary"
            transformText={false}
          />
          <br />
          <Grid container justify="center" spacing={5}>
            {advisories.map((advisory, idx) => (
              <Grid key={idx} item lg={4} md={4} xs={12} sm={12}>
                <AdvisoryItem advisory={advisory} />
              </Grid>
            ))}
          </Grid>
          <br />
          <br />
          <DividerButton link="advisories" button="View All Advisories" />
        </Container>
        <br />
      </div>
    </div>
  );
};

export default withStyles(style)(Home);
